import React from 'react';

export const WildberriesIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 638 638'
            fill='none'
        >
            <path
                d='M319 0C495.179 0 638 142.821 638 319C638 495.179 495.179 638 319 638C142.821 638 0 495.179 0 319C0 142.821 142.821 0 319 0Z'
                fill='url(#paint0_linear_18223_50871)'
            />
            <path
                d='M478.205 239.848C456.368 239.848 436.604 246.436 419.769 257.781V154.512H373.166V344.825C373.166 402.712 420.257 449.315 477.9 449.315C535.543 449.315 583.182 403.017 583.182 344.276C583.243 285.596 536.641 239.848 478.205 239.848ZM266.725 358.306L224.087 247.229H191.454L148.572 358.306L105.629 247.229H54.8181L129.846 442.544H162.479L207.496 326.221L252.756 442.544H285.39L360.174 247.229H309.607L266.725 358.306ZM477.961 402.773C446.364 402.773 419.769 377.52 419.769 344.581C419.769 311.642 444.778 286.694 478.205 286.694C511.632 286.694 536.641 312.74 536.641 344.581C536.641 376.483 510.046 402.773 477.961 402.773Z'
                fill='white'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_18223_50871'
                    x1='126.32'
                    y1='640.133'
                    x2='517.821'
                    y2='-12.3682'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#6F01FB' />
                    <stop offset='1' stopColor='#FF49D7' />
                </linearGradient>
            </defs>
        </svg>
    );
};
